import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AvailabilityState, AvailabilityStore } from "./availability.store";

/** An implementation for which the application is always available */
@Injectable()
export class AvailabilityStoreNoCheckImpl implements AvailabilityStore {
  private _available$ = new BehaviorSubject<AvailabilityState>(undefined);

  /** @return Whether the application is available for the current user */
  get available$(): Observable<AvailabilityState> {
    return this._available$.asObservable();
  }

  initialize() {
    this._available$.next("yes");
  }
}
